import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import HackerOneMappingForm from './HackerOneMappingForm';

function HackerOneCredentialsForm(props, ref){
    const fields = [{
        name: "identifier",
        label: "Identifier",
        required: true
    },{
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={HackerOneMappingForm}
        />
    )
}

export default forwardRef(HackerOneCredentialsForm);